import { API } from "../../utils/api";
import { HTTP_METHODS } from "../../utils/constants";
import { networkUploadRequest } from "../../utils/networkUtils";

const networkBackendRequest = function (
  httpMethod: string,
  params?: any,
  body?: any,
  signal?: any
) {
  if (!params) params = {};
  let url = API.COMPLAINTS.URL + "presigned/upload";
  if (params) {
    let count = 0;
    for (const key in params) {
      if (!Array.isArray(params[key])) {
        params[key] = [params[key]];
      }
      /*eslint-disable */
      params[key].forEach((e) => {
        if (count === 0) {
          url += `?${key}=${encodeURIComponent(e)}`;
        } else {
          url += `&${key}=${encodeURIComponent(e)}`;
        }
        count++;
      });
    }
  }

  return fetch(url, {
    method: httpMethod,
    headers: {
      accept: "*/*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    signal: signal,
  })
    .then((response) => {
      if (response.ok) return response;
      throw response;
    })
    .catch((eResponse) => {
      // TODO: The server may return an error object,
      // and is converted using .json. Review this later
      return eResponse.json().then((data) => {
        const error = { ...data, status: eResponse.status };
        throw error;
      });
    });
};

export default function uploadFileToS3(documentType, files, prefix) {
  return Promise.all(
    files.map((file, idx) => {
      const fileExt = (/\.[^.]*$/.exec(file.name) || [""])[0];
      const filename = `${prefix}${idx + 1}${fileExt}`;
      return networkBackendRequest(HTTP_METHODS.GET, {
        file_type: documentType,
        content_type: file.type,
      })
        .then((response) => response.json())
        .then((presignedPostRequest) => {
          const request = presignedPostRequest.message;
          const formData = new FormData();

          /*eslint-disable */
          const objectName = request.fields["key"].replace(
            "${filename}",
            filename
          );
          Object.keys(request.fields).forEach((key) => {
            formData.append(key, request.fields[key]);
          });
          formData.append("file", file, filename);
          return networkUploadRequest(
            request.url,
            HTTP_METHODS.POST,
            null,
            formData
          ).then(() => objectName);
        });
    })
  );
}
